import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=484df742&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=484df742&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484df742",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fsearch-bar%2FSearchBar.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports